<div id="alerts-container-filters" class="selects-container">
  <app-wallet-select
    [id]="'alerts-select-wallet'"
    [(ngModel)]="selectedWallet"
    [showWalletTypeIcon]="true"
    [disabled]="isLoading()"
    [enableAutoSelect]="true"
    (selectionChange)="onWalletSelect($event)"
    data-testid="wallet-select"
  ></app-wallet-select>

  <mat-form-field appearance="outline" style="width: 100%; user-select: none">
    <mat-select
      id="alerts-select-indicator"
      [ngModel]="selectedIndicator()"
      (selectionChange)="onIndicatorsSelect($event)"
      [disabled]="isIndicatorSelectDisabled()"
      data-testid="indicator-select"
    >
      @if (selectedIndicator()) {
        <mat-select-trigger>{{ getIndicatorOptionName(selectedIndicator()!) }}</mat-select-trigger>
      }
      @for (
        indicator of indicators();
        track (indicator.id ?? indicator.name) + '__' + (indicator.relationshipLevel ?? '')
      ) {
        <mat-option
          [value]="indicator"
          [ngClass]="{ 'parent-indicator-option': isParentIndicator(indicator) }"
        >
          @if (isParentIndicator(indicator) && !isLoadingIndicators()) {
            <img [src]="selectOptionImage()" style="max-width: 30px" alt="Estatica" />
          }
          <span class="indicator-option">{{ indicator.name }}</span>
        </mat-option>
      }
    </mat-select>
    <mat-label><strong i18n="@@attribute">Atributo:</strong></mat-label>
  </mat-form-field>

  <app-search-input
    [id]="'alerts-input-search'"
    [inputLabel]="documentInputSearchLabel()"
    [placeholder]="'Buscar documento'"
    [(value)]="searchedDocument"
    [disabledSearch]="isLoading()"
    [customValidator]="documentValidator"
    (searchTriggered)="onSearchTriggered()"
    [mask]="documentSearchMask()"
  ></app-search-input>
</div>

<div id="alerts-container-last-update" class="last-period-container">
  <div>
    <span i18n="@@lastAlertSend">Último envío de alertas:</span>
    <strong id="alerts-lbl-last-update">{{ lastProcessingDate() }}</strong>
  </div>
  <app-icon
    name="help_outlined"
    size="24"
    alt="Help icon"
    [color]="'#1976d2'"
    i18n-matTooltip
    matTooltip="Los alertas se actualizan semanalmente."
  ></app-icon>
</div>

<div id="alerts-container-table" class="table-content">
  <app-generic-table
    [id]="'alerts-table'"
    [config]="tableConfig"
    [data]="alerts()"
    [isLoading]="isLoading()"
    [noDataMessage]="noDataMessage"
    [page]="pagination().page"
    [pageSize]="pagination().perPage"
    [totalRegisters]="pagination().totalRegisters"
    (pageChange)="changePage($event)"
  >
    <ng-template appTableCell="document" let-alert>
      @if (personType() === 'PERSON') {
        <span>{{ alert.document | cpfMask }}</span>
      } @else {
        <span>{{ alert.document | cnpjMask }}</span>
      }
    </ng-template>

    <ng-template appTableCell="_summaryOfChanges" let-alert>
      <app-alert-indicators-tags [data]="alert._combinedAlerts" />
    </ng-template>

    <ng-template appTableExpandableContent let-alert let-index="index">
      <div style="padding: 16px; width: 100%">
        <app-carousel
          [id]="'alerts-carousel-' + index"
          [items]="facade.getAlertVariationCards(alert._combinedAlerts)"
          [itemWidth]="'240px'"
        >
          <ng-template #carouselItem let-detail>
            <app-alert-variation-card
              [data]="detail"
              (cardClick)="onPartnerCardClick(detail, alert)"
            ></app-alert-variation-card>
          </ng-template>
        </app-carousel>
      </div>
    </ng-template>

    <ng-template #noDataContent>
      <div id="alerts-empty-state-container" class="no-data-container">
        @if (hasError()) {
          <img src="assets/images/danger.svg" alt="Error" width="80" />
          <span id="alerts-empty-state-error" i18n="@@errorRetrievingData">Error al intentar recuperar los datos.</span>
        } @else {
          <img src="assets/images/warning.svg" alt="Warning" width="80" />
          @if (!hasNoIndicators()) {
            <span id="alerts-empty-state-no-data" i18n="@@noDataDisplayAlertsReport">
              No se observó variación en los atributos monitoreados para su visualización en el
              informe.
            </span>
          } @else {
            <span id="alerts-empty-state-no-attributes" i18n="@@noAttributesForWalletPlan">
              El plan de esta cartera no tiene atributos disponibles para enviar alertas.
            </span>
          }
        }
      </div>
    </ng-template>
  </app-generic-table>
</div>
